import React from 'react';
import { guarantees, productImage } from '../data/content';
import { CtaButton } from './CtaButton';
export function FinalCta() {
  return <section className="w-full bg-royal px-5 py-20 text-white sm:py-28" data-id="element-96" data-mp="vgqygnh3faik">
      <div className="mx-auto grid max-w-5xl items-center gap-10 text-center md:grid-cols-[0.75fr_1.25fr] md:text-left" data-id="element-97" data-mp="19g0dhjtkbyky">
        <img src={productImage} alt="The CAREER READY™ six-volume collection" className="mx-auto w-full max-w-[220px] md:max-w-none" data-id="element-98" data-mp="15bsnzkfa6elo" />
        <div data-id="element-99" data-mp="1ee1w63n2tvvw">
          <h2 className="font-display text-[1.75rem] font-black leading-tight tracking-tight sm:text-5xl" data-id="element-100" data-mp="1eebldp0arz0j">
            Stop Planning Every Career Readiness Lesson From Scratch.
          </h2>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-white/80 md:max-w-none" data-id="element-101" data-mp="1o3vavdiimr4d">
            Give yourself an organized set of materials for helping students
            explore careers, practice workplace skills, and think about their
            next steps.
          </p>
          <p className="mt-4 font-display text-lg font-bold text-sun sm:text-xl" data-id="element-102" data-mp="1x2p02itiof7w">
            Six complete volumes. Five practical bonuses. One payment of $27.
          </p>
          <CtaButton label="Get the CAREER READY™ Pack Now" className="mt-8" data-id="element-103" data-mp="s4xqxmapttoq" />
          <p className="mt-6 text-xs font-semibold text-white/75 sm:text-sm" data-id="element-104" data-mp="x2z9850bhoz5">
            {guarantees.join(' · ')}
          </p>
        </div>
      </div>
    </section>;
}